import { SupportChainIDs } from '@/constant';
import { getDefaultConfig, getDefaultWallets } from '@rainbow-me/rainbowkit';
import {
    argentWallet,
    imTokenWallet,
    ledgerWallet,
    okxWallet,
    oneKeyWallet,
    trustWallet,
    uniswapWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { bsc, bscTestnet } from 'viem/chains';
import { lazaiMainnet } from './lazaiMainnetChain';
import { lazaiTestnet } from './lazaiTestnetChain';

export const projectId = 'e1b0a7ab8ea35f139488ce08f9a8afa0';
const allChains = [lazaiMainnet, lazaiTestnet, bsc, bscTestnet];

const { wallets: defaultWallets } = getDefaultWallets();
const wallets = [
    ...defaultWallets,
    {
        groupName: 'Other',
        wallets: [
            argentWallet,
            trustWallet,
            ledgerWallet,
            okxWallet,
            imTokenWallet,
            uniswapWallet,
            oneKeyWallet,
        ],
    },
];

const chainConfig = {
    chains: allChains.filter((chain) => SupportChainIDs.includes(chain.id)),
    appName: 'Lazbubu Protocol',
    projectId: projectId,
    wallets,
};

export default getDefaultConfig(chainConfig as any);
